export default __webpack_public_path__ + "static/media/imageThree.240cad6a.jpg";